export const getFrench = (str) => {
  switch (str) {
    case 'JANUARY':
    case 1:
      return 'JANVIER'
    case 'FEBRUARY':
    case 2:
      return 'FÉVRIER'
    case 'MARCH':
    case 3:
      return 'MARS'
    case 'APRIL':
    case 4:
      return 'AVRIL'
    case 'MAY':
    case 5:
      return 'PEUT'
    case 'JUNE':
    case 6:
      return 'JUIN'
    case 'JULY':
    case 7:
      return 'JUILLET'
    case 'AUGUST':
    case 8:
      return 'AOÛT'
    case 'SEPTEMBER':
    case 9:
      return 'SEPTEMBRE'
    case 'OCTOBER':
    case 10:
      return 'OCTOBRE'
    case 'NOVEMBER':
    case 11:
      return 'NOVEMBRE'
    case 'DECEMBER':
    case 12:
      return 'DÉCEMBRE'
    case 'edit':
      return 'Modifier'
    case 'delete':
      return 'Supprimer'
    case 'saturday':
      return 'Samedi'
    case 'sunday':
      return 'Dimanche'
    case 'monday':
      return 'Lundi'
    case 'tuesday':
      return 'Mardi'
    case 'wednesday':
      return 'Mercredi'
    case 'thursday':
      return 'Jeudi'
    case 'friday':
      return 'Vendredi'
    case 'is_periodic':
      return 'Is Periodic'
    case 'is_daily':
      return 'Quotidienne'
    case 'is_weekly':
      return 'Hebdomadaire'
    case 'is_monthly':
      return 'Mensuelle'
    case 'is_yearly':
      return 'Annuelle'
    default:
      return ''
  }
}
